import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { SapiService, SapiEntity, SapiQueryResponse } from '../sapi.service';
import { LocationService } from '../location.service';

import { ServiceLocator } from '../../modules/abstract.module';
import { Adapter } from '../../interfaces/adapter';

export class GenericService<T extends Adapter<A>, A> {

	protected apiPath = '';

	private sapiService: SapiService;
	private http: HttpClient;
	private locationService: LocationService;

	constructor(private adapter: T) {
		this.http = ServiceLocator.injector.get(HttpClient);
		this.sapiService = ServiceLocator.injector.get(SapiService);
		this.locationService = ServiceLocator.injector.get(LocationService);
	}

	get(id: string, params?: HttpParams | any): Observable<A> {
		const path = id;
		return this._httpGet(path, params as HttpParams).pipe(
			map((data: SapiEntity) => this.adapter.adapt(data))
		);
	}

	list(): Observable<A[]> {
		return this._httpGet().pipe(
			// Adapt each item in the raw data array
			map((data: SapiQueryResponse) => {
				let items: A[] = [];
				if (data && data.items) {
					items = data.items.map(item => this.adapter.adapt(item));
				}
				return items as A[];
			})
		);
	}

	private _httpGet(extraPath?: string, params?: HttpParams) {
		const requestOptions = this.sapiService.determineRequestOptions();
		if (params) {
			requestOptions.params = params;
		}
		let path = this.locationService.server + '/sapi/' + this.apiPath;
		if (extraPath) {
			path += '/' + extraPath;
		}
		return this.http.get(path, requestOptions);
	}
}
